<template>
  <div class="wrapper" data-app>
    <div class="box-content1">
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="9"
          ><div class="grid-content bg-purple text-bill1">
            {{ $t("invoiceCode") }}
          </div></el-col
        >
        <el-col :span="9" class="column-wrapper">
          <div class="grid-content bg-purple text-right text-bill2">
            {{ billDetail?.code }}
          </div>
        </el-col>
      </el-row>

      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="18"
          ><div class="grid-content bg-purple text-bill1">
            {{ $t("numberOfPaymentServices") }}
          </div>
        </el-col>
        <el-col :span="9" class="column-wrapper">
          <div class="grid-content bg-purple text-right text-bill2">
            {{ billDetail?.total_services }}
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="4"
          ><div class="grid-content bg-purple text-bill1">
            {{ $t("yard") }}:
          </div></el-col
        >
        <el-col :span="20" class="column-wrapper">
          <div class="grid-content bg-purple text-right text-bill2">
            {{
              billDetail?.services[0]?.booking_pax_detail?.facility?.sub_title
            }}
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="9"
          ><div class="grid-content bg-purple text-bill1">
            {{ $t("playTime") }}:
          </div></el-col
        >
        <el-col :span="15" class="column-wrapper">
          <div class="grid-content bg-purple text-right text-bill2">
            {{
              formatDate(
                billDetail?.services[0]?.booking_pax_detail?.date_played,
                "HH:mm - DD/MM/YYYY"
              )
            }}
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="9"
          ><div class="grid-content bg-purple text-bill1">
            {{ $t("booker") }}
          </div></el-col
        >
        <el-col :span="15" class="column-wrapper">
          <div class="grid-content bg-purple text-right text-bill2">
            {{ billDetail?.user_book }}
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="12"
          ><div class="grid-content bg-purple text-bill1">
            {{ $t("phoneNumber") }}
          </div></el-col
        >
        <el-col :span="15" class="column-wrapper">
          <div class="grid-content bg-purple text-right text-bill2">
            {{ billDetail?.phone }}
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { formatDate } from "@/utils/formatData";

export default {
  components: {}, //, Comment
  bodyClass: "info-detail-bill",
  props: {
    billDetail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  created() {},

  watch: {},

  methods: {
    formatDate
  }
};
</script>
<style lang="scss" scoped>
.box-content {
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color: #fff !important;
  //box-shadow: 0px 0px 4px 0px #00000026;
  overflow-y: auto;
  //max-height: 490px;
  margin-bottom: 136px;
}

.checkbox {
  margin-left: 2px;
}

.title {
  font-size: 14px;
  font-weight: 600;
}

.quantity,
.status {
  display: block;
  font-size: 14px;
  font-weight: 400;
}

//.price-info {
//  display: -webkit-flex;
//  height: 25px;
//}

.arrow-icon {
  width: 15px;
}

.details {
  background-color: #021944;
  padding: 10px;
  transition: 5s;
}

.detail-info {
  margin-bottom: 15px;
}

.detail-info span {
  display: block;
  font-size: 14px;
  color: #fff;
  font-weight: 400;
}

//.participant {
//  margin-top: 5px;
//}

.participant-price {
  display: block;
  font-size: 14px;
  color: #000;
  font-weight: 400;
}

.payment-details {
  width: 100%;
  background-color: #f5f5f5;
  position: fixed;
  bottom: 0px; /* Khoảng cách từ bottom của trang */
  left: 0;
  right: 0;
  z-index: 9999; /* Đảm bảo .payment-details luôn ở phía trên các phần tử khác */
}

.content {
  margin-right: 12px;
  margin-left: 12px;
}

.box-content1 {
  border-radius: 8px;
  padding: 15px;
  background-color: #fff !important;
  box-shadow: 0px 0px 4px 0px #00000026;
}
.text-bill1 {
  font-size: 12px;
  color: #999999;
}
.text-bill2 {
  font-size: 14px;
}
.column-wrapper {
  display: flex;
  justify-content: flex-end;
}

.mobile {
  display: none;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
</style>

<style lang="scss">
@media screen and (min-width: 0px) and (max-width: 769px) {
}
</style>
